import "../../Site.css";
import SignupUser from "../UserManagement/SignupUser";

function Signup() {
    return (
        <SignupUser screenName="Sign up  user" create={false} />
    )
}
export default Signup;
